import React from 'react';
import { useFeatureFlag } from '../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../CommonSelectors/CommonArea.types';
import { WebComponentWorkflow } from './components/WebComponentWorkflow/WebComponentWorkflow';
import { IFrameWorkflow } from './components/IFrameWorkflow/IFrameWorkflow';

interface Props {
  onFinish?(): void;
}

export const HiddenLeversRTQ: React.FC<Props> = ({ onFinish }) => {
  const isWebComponent = useFeatureFlag(Feature.HiddenLeversRTQWebComponent);

  if (isWebComponent) {
    return <WebComponentWorkflow onFinish={onFinish} />;
  }

  return <IFrameWorkflow onFinish={onFinish} />;
};
